// feed-item types
export const REVIEWS_CREATED = 'reviews:created';
export const TRAIL_COMPLETED = 'trail:completed';
export const TRAIL_PHOTOS_UPLOADED = 'trail:photos:uploaded';
export const ACTIVITY_CREATED = 'recording:created';
export const ACTIVITY_PHOTOS_UPLOADED = 'recording:photos:uploaded';
export const LIST_ITEM_ADDED = 'list:item:added';
export const LIST_CREATED = 'list:created';

// section-types
export const FEED_ITEM = 'feed-item';
export const FOLLOW_SUGGESTION = 'follow-suggestion';

// suggested member types
export const SUGGESTED_MEMBER = 'SUGGESTED_MEMBER';
export const SUGGESTED_FACEBOOK = 'SUGGESTED_FACEBOOK';
export const SUGGESTED_CONTACTS = 'SUGGESTED_CONTACTS';
export const SUGGESTED_MORE = 'SUGGESTED_MORE';

// modals
export const LIGHTBOX = 'LIGHTBOX';
export const SAVE_TO_LIST = 'SAVE_TO_LIST';
export const SUGGESTIONS_MODAL = 'SUGGESTIONS_MODAL';
export const INVITE_FRIENDS_MODAL = 'INVITE_FRIENDS_MODAL';
export const FIND_FRIENDS_MODAL = 'FIND_FRIENDS_MODAL';
export const CONNECT_MODAL = 'CONNECT_MODAL';
